import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { Container } from './ui/Container';
import { CheckItem } from './ui/CheckItem';
import { forWhoYes, forWhoNo } from '../data/sections';
const easeOut: [number, number, number, number] = [0.23, 1, 0.32, 1];
export function ForWhoSection() {
  return <section className="bg-mp-black py-20 md:py-28" data-id="element-148" data-mp="2c73pfr8pe5ir">
      <Container data-id="element-149" data-mp="286bgkz3qu2n0">
        <div className="grid grid-cols-1 gap-6 lg:grid-cols-[1.3fr_1fr] lg:gap-8" data-id="element-150" data-mp="286tiocd37b2u">
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          ease: easeOut
        }} className="rounded-2xl border border-mp-border bg-mp-card p-7 md:p-9" data-id="element-151" data-mp="236fn3tso9tlp">
            <h2 className="font-heading text-2xl uppercase leading-tight text-mp-white sm:text-3xl" data-id="element-152" data-mp="3skc34hzud9se">
              Maestro en Pista es para ti si...
            </h2>
            <ul className="mt-6 space-y-3.5" data-id="element-153" data-mp="1sacoa7km9md0">
              {forWhoYes.map(item => <CheckItem key={item} data-id="element-154" data-mp="1x8w924nh4s3s">{item}</CheckItem>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          ease: easeOut,
          delay: 0.05
        }} className="rounded-2xl border border-mp-border bg-mp-dark p-7 md:p-9" data-id="element-155" data-mp="1icexpdfabdh8">
            <h3 className="font-heading text-lg uppercase leading-tight text-mp-gray sm:text-xl" data-id="element-156" data-mp="2fycdh32a54ph">
              Probablemente no es para ti si...
            </h3>
            <ul className="mt-6 space-y-3.5" data-id="element-157" data-mp="269c9t6cu1l4y">
              {forWhoNo.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-158" data-mp="2tzoqp6q22s7o">
                  <XIcon className="mt-0.5 h-4 w-4 flex-shrink-0 text-mp-gray/60" strokeWidth={2.5} data-id="element-159" data-mp="2txbym0ql31gw" />
                  <span className="text-sm text-mp-gray/80 md:text-[15px]" data-id="element-160" data-mp="2ys85g70hbte2">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </Container>
    </section>;
}